(function () {
    "use strict";

    angular
        .module("app")
        .directive("storyTypeSearchHelp", ["SearchFactory", storyTypeSearchHelp]);

    function storyTypeSearchHelp(searchFactory) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.search = function (forValidation) {
                    if (scope.readOnly === true) {
                        return;
                    }

                    if (forValidation && (!scope.displayValue || scope.displayValue.trim().length === 0)) {
                        scope.storyTypeName = "";
                        scope.storyTypeKey = "";
                        scope.prevDisplayValue = "";
                        scope.displayValue = "";
                        return;
                    }

                    scope.needToValidate = forValidation ? true : false;

                    if (forValidation && (scope.prevDisplayValue === scope.displayValue || scope.storyTypeName === scope.displayValue)) {
                        scope.needToValidate = false;
                        return;
                    }

                    var modalSearch = searchFactory.storyTypeSearch(function (storyType) {
                        scope.storyTypeKey = storyType ? storyType.CharacteristicValue : "";
                        scope.storyTypeName = storyType ? storyType.CharacteristicDesc : "";
                        scope.displayValue = scope.storyTypeName;

                        if (scope.prevDisplayValue !== scope.displayValue) {
                            scope.setDirtyCallback();
                        }

                        scope.prevDisplayValue = scope.displayValue;
                        scope.needToValidate = false;

                    });

                    modalSearch.startSearch(forValidation, ["", scope.displayValue]);
                };

                scope.$watch("storyTypeName", function (newValue) {
                    scope.displayValue = newValue;
                });

                scope.displayValue = scope.storyTypeName;
                scope.prevDisplayValue = scope.displayValue;

            },
            scope: { storyTypeKey: "=", storyTypeName: "=?", readOnly: "=", required: "=", controlName: "@", needToValidate: "=?", setDirtyCallback: "&" },
            templateUrl: templateUrl("app/directives/searchHelp/searchHelp.directive.html")
        };
    }
})();

